// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  RECAPTCHA_SITE_KEY: "6Le7kO8ZAAAAAB8kG3zVsEU1edIkD--lhZR9K_KN",

  snackBarMessages : {
    'basicErrorMessage' : $localize`:@@bar.basicErrorMessage:Something Went Wrong, Please Try Again`,
    'loginSuccess' : $localize`:@@bar.loginSuccess:Login Successful`,
    'logoutSuccess' : $localize`:@@bar.logoutSuccess:Logged Out !`,
    'messageSent' : $localize`:@@bar.messageSent:Message Sent`,
    'settingsChanged' : $localize`:@@bar.settingsChanged:Settings Changed Successfully`,
    'imageLoadingFailed' : $localize`:@@bar.imageLoadingFailed:Image Loading Failed`,
    'postUpdated' : $localize`:@@bar.postUpdated:Post Updated Successfully`,
    'postCreated' : $localize`:@@bar.postCreated:Post Created Successfully`,
    'postDeleted' : $localize`:@@bar.postDeleted:Post Deleted Successfully`,
    'enterValidForm' : $localize`:@@bar.enterValidForm:Please Enter a Valid Form`,
    'blogDeleted' : $localize`:@@bar.blogDeleted:The Blog is Deleted`,
    'accessDenied' : $localize`:@@bar.accessDenied:Access Denied.`,
    'notLoggedInMessage' : $localize`:@@bar.notLoggedInMessage:You are not Logged In`,
    'imageSizeLimitMessage' : $localize`:@@bar.imageSizeLimitMessage:Size Limit Exceeded: Image should be less than 5 MB`,
    'emptyField' : $localize`:@@bar.emptyField:Field is empty.`
  }
};

export const api_urls = {
  // API_ENDPOINT: 'https://fahrplantoolapi.azurewebsites.net/', //for fahrplantool site
  // API_ENDPOINT: 'https://api.matchrider.de/', //for mobilitydiy site
  getHighlightedBlogEntries : "https://api.matchrider.de/api/blog/GetHighlightedBlogEntries",
  getHighlightedBlogs : "https://api.matchrider.de/api/blog/GetHighlightedBlogs",
  saveBlogEntry : "https://api.matchrider.de/api/blog/SaveBlogEntry",
  getBlogSettings : "https://api.matchrider.de/api/2.0/blog/GetBlogSettings",
  getBlogSettingsByUrl : blogUrl => `https://api.matchrider.de/api/blog/GetBlogSettingsByUrl/${blogUrl}`,
  saveBlogSettings : "https://api.matchrider.de/api/blog/SaveBlogSettings",
  saveBlogSiteSettings : "https://api.matchrider.de/api/Blog/SaveBlogSiteConnector",
  saveBlogFaceShot : "https://api.matchrider.de/api/blog/SaveBlogFaceShot",
  uploadImage : "https://api.matchrider.de/api/blog/UploadImage",
  uploadBackgroundImage : "https://api.matchrider.de/api/blog/UploadBackgroundImage",
  getBlogEntries : blogUrl => `https://api.matchrider.de/api/blog/GetBlogEntries/${blogUrl}`,
  getBlogEntry : (blogUrl, blogEntryId) => `https://api.matchrider.de/api/blog/GetBlogEntry/${blogUrl}/${blogEntryId}`,
  sendBlogEmail : "https://api.matchrider.de/api/blog/SendBlogEmail",
  deleteBlog : "https://api.matchrider.de/api/2.0/blog/DeleteBlog",
  deleteBlogEntry : blogEntryId => `https://api.matchrider.de/api/2.0/blog/DeleteBlogEntry/${blogEntryId}`,
  getBlogSiteConnector : "https://api.matchrider.de/api/blog/GetBlogSiteConnector",
  validateAdminBlogUser : "https://api.matchrider.de/api/login/ValidateAdminBlogUser",
  getAvailableRoutesForMap : communityId => `https://api.matchrider.de/api/preConfiguredRoute/GetAvailableRoutesByCommunityForMap/${communityId}`,
  getMatchPoints : communityId => `https://api.matchrider.de/api/preConfiguredRoute/MatchPointsOnPreconfiguredRoutesByCommunity/${communityId}`,
  getCommunityById: communityId => `https://api.matchrider.de/api/Community/GetCommunityById/${communityId}`
}

export const default_images = {
  faceshot : "assets/img/default-faceshot.png", // image ratio 1:1
  icon : "assets/img/matchrider-logo.png", // image ratio 1:1
  website : "assets/img/about-bg.jpg", // 16:9
  blogHome : "assets/img/home-bg.jpg", // 16:9
  aboutme : "assets/img/about-bg.jpg", // 16:9
  post : "assets/img/home-bg.jpg", // 16:9
  contact : "assets/img/contact-bg.jpg" // 16:9
}

export const MatchRiderSocialLinks = {
  facebook : 'https://www.facebook.com/Match.Rider',
  twitter : 'https://twitter.com/MatchRider'
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
